import React, { useEffect, useContext } from 'react'
import Col from '../../../UIcomponent/Column'
import LocalContext from '../../../Context/LocalContetxt'
import { FilterList } from './FilterList'
import './TeachersFilter.scss'
const FilterItem = (props) => {
    const { activeFilter } = props
    let item = props.item ? props.item : FilterList
    const lang = useContext(LocalContext).lang
    useEffect(() => {
    }, [])
    let Items = item.map((filter, index) => {
        return (
            <Col
                xl={24} lg={24} md={24} sm={24} xs={24}
                className={`${filter.title === activeFilter && 'o__TeachersFilter__Sort__Item--active'} o__TeachersFilter__Sort__Item`}
                style={{
                    margin: '0px 2px 0px 2px',
                    display: index === 0 && 'none',
                }}
            >
                <Col
                    onClick={filter.title !== activeFilter ? () => props.onSelect(filter.title) : props.onDeselect}
                    width='auto'
                >
                    <Col
                        className={`${filter.title === activeFilter ? 'c__itemRadio--Selected' : 'c__itemRadio'}`}
                    >
                        {
                            filter.title === activeFilter &&
                            <Col
                                className='o__itemRadio'
                            ></Col>
                        }
                    </Col>

                    <Col>
                        {filter.name[`${lang}`]}
                    </Col>
                    {/* {deletableSort && filter.title === activeFilter &&
                        <Col
                            className='c__removeSort'
                            onClick={props.removeSortHandler}
                        >

                            <Icon type="close"
                            />
                        </Col>
                    } */}
                </Col>
            </Col>
        )
    })
    return (
        <>
            {Items}
        </>
    )
}

export default FilterItem
